import React from "react";

import Section from "./Section";

interface FAQ {
  question: string;
  answer: React.ReactNode;
}

const faqs: FAQ[] = [
  {
    question: "How do you ensure my safety?",
    answer:
      "Safety is our top priority. Every member goes through a manual verification process through a phone call to ensure that all group members are women. Plus, we enforce a strict no-tolerance policy for inappropriate behavior. If you ever feel uncomfortable, you can leave the WhatsApp group at any time. We also encourage members to share their travel plans with friends or family for added security.",
  },
  {
    question: "What data do you collect and how is it protected?",
    answer:
      "We collect only essential information: your name, age and WhatsApp number. We never share your personal information with third parties.",
  },
  {
    question: "Where is Cohop currently operational?",
    answer:
      "Currently, Cohop has groups for Bengaluru, Mumbai, Delhi, Hyderabad, Pune, and Kolkata. We're actively working to expand to more cities based on demand.",
  },
  {
    question: "Do you provide transportation or just connections?",
    answer:
      "We facilitate connections between verified women travelers, but you arrange your own transportation (cab, rideshare, etc.). This gives you full control over your journey while ensuring you have trusted company for the ride.",
  },
  {
    question:
      "I got the Cohop WhatsApp community invite. When should I join the group?",
    answer: (
      <>
        As soon as you can. Joining early simply makes you part of a community
        of women travelers,which is super useful for:
        <ul className="list-disc list-inside">
          <li>Finding co-travelers to/from the airport</li>
          <li>Getting tips & recommendations to explore the city</li>
          <li>Ensuring safety tips across your travel regime</li>
          <li>Connecting with other women traveling in Bengaluru</li>
          <li>Sharing local commute info & quick travel help</li>
        </ul>
      </>
    ),
  },
  {
    question: "Is there any cost to join Cohop?",
    answer:
      "Joining Cohop is completely free with no hidden charges. Our mission is to make travel safer for women, not to profit from safety concerns.",
  },
];

const FAQSection: React.FC = () => {
  return (
    <Section id="faq" height="medium" className="border-b border-pink-200">
      <div className="max-w-2xl w-full">
        <h3 className="text-3xl font-semibold text-purple-800 text-center mb-12 font-display">
          Frequently Asked Questions
        </h3>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <details
              key={index}
              className="group bg-white/60 rounded-xl p-4 border border-pink-200 hover:border-purple-300 transition-all duration-300"
            >
              <summary className="cursor-pointer font-medium text-purple-700 hover:text-purple-900 py-2 flex justify-between items-center">
                <span>{faq.question}</span>
                <span className="transform group-open:rotate-180 transition-transform duration-500 ease-in-out text-pink-400">
                  ▼
                </span>
              </summary>
              <p className="mt-3 text-gray-600 leading-relaxed">{faq.answer}</p>
            </details>
          ))}
        </div>
      </div>
    </Section>
  );
};

export default FAQSection;
